/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_Ingestion_TitleInputs */

const es_prompt_tips_ingestion_title = /** @type {(inputs: Prompt_Tips_Ingestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicá si los archivos están ingeridos`)
};

const en_prompt_tips_ingestion_title = /** @type {(inputs: Prompt_Tips_Ingestion_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicate if files are ingested`)
};

/**
* | output |
* | --- |
* | "Indicate if files are ingested" |
*
* @param {Prompt_Tips_Ingestion_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_ingestion_title = /** @type {((inputs?: Prompt_Tips_Ingestion_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_Ingestion_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_ingestion_title(inputs)
	return en_prompt_tips_ingestion_title(inputs)
});
export { prompt_tips_ingestion_title as "prompt_tips.ingestion_title" }